import { render, staticRenderFns } from "./Testbank.vue?vue&type=template&id=b3431d2a&scoped=true&"
import script from "./Testbank.vue?vue&type=script&lang=js&"
export * from "./Testbank.vue?vue&type=script&lang=js&"
import style0 from "./Testbank.vue?vue&type=style&index=0&id=b3431d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3431d2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3431d2a')) {
      api.createRecord('b3431d2a', component.options)
    } else {
      api.reload('b3431d2a', component.options)
    }
    module.hot.accept("./Testbank.vue?vue&type=template&id=b3431d2a&scoped=true&", function () {
      api.rerender('b3431d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/Testbank.vue"
export default component.exports